import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { CachedAttr, CACHE_TYPES } from '@yourcause/common/cache';
import { } from '@yourcause/common/state';

/**
 * Service to store the attempted route and allows for navigation to that route after the user has logged in.
 */
@Injectable({ providedIn: 'root' })
export class DeepLinkingService {
  @CachedAttr(CACHE_TYPES.LOCALSTORAGE)
  private _attemptedRoute: string;

  constructor (
    private router: Router
  ) { }

  calculatePathname () {
    return location.pathname +
      (location.search || '') +
      (location.hash || '');
  }

  get attemptedRoute () {
    return this._attemptedRoute;
  }

  attemptDeepLinking (route: string) {
    this.router.navigateByUrl(this._attemptedRoute || route, /* Removed unsupported properties by Angular migration: queryParamsHandling. */ {});
    this.clearAttemptedRoute();
  }

  setAttemptedRoute (route = this.calculatePathname()) {
    if (route && route !== '/') {
      this._attemptedRoute = route;
    }
  }

  clearAttemptedRoute () {
    this._attemptedRoute = null;
  }

  private getExtraRouteParams (queryParams: Params): Params {
    return {queryParams: queryParams ?? {}};
  }

  attemptDeepLink (route: string, queryParams?: Params) {
    const existingRoute = this._attemptedRoute;
    const _route = existingRoute || route;

    const [path, queryString] = _route.split('?');
    const extras = this.getExtraRouteParams(queryParams);
    if (queryString) {
      queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        extras.queryParams[key] = value;
      });
    }

    if (!!extras) {
      this.router.navigate([path], extras);
    } else {
      this.router.navigateByUrl(path);
    }
    this.clearAttemptedRoute();
  }
}
